/**************************************************
 * Nombre:       IngresoSelectTextoArray
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Chip, InputAdornment, MenuItem, TextField} from "@mui/material";
import {Brightness1} from "@mui/icons-material";
import {useEffect, useState} from "react";
import {Grid} from "@mui/system";


const IngresoSelectTextoArray = ({
                                     props,
                                     nombre,
                                     dato,
                                     Icono = Brightness1,
                                     requerido = false,
                                     size = 'small',
                                     editable = true,
                                     opciones = []
                                 }) => {
    const {register, errors, control, watch, setValue, getValues} = props
    const [selecciones, setSelecciones] = useState([])
    const [escogido, setEscogido] = useState('')
    const [cargar, setCargar] = useState(false)

    const agregar = () => {

        let index = selecciones.findIndex((e) => e === escogido)
        if (index === -1) {

            let arr = selecciones
            arr.push(escogido)
            setValue(dato, arr)
            setCargar(!cargar)

        }

    }

    const borrar = (index) => {

        let arr = selecciones
        arr.splice(index, 1)
        setValue(dato, arr)
        setCargar(!cargar)


    }


    useEffect(() => {

        let valor = getValues(dato)
        if (valor) {
            setSelecciones(valor)
        }

    }, [watch(dato), cargar])
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={8} sx={{justifyContent: 'flex-start'}}>
                <TextField
                    slotProps={{
                        input: {
                            startAdornment: (

                                <InputAdornment position="start">
                                    <Icono color={'primary'}/>
                                </InputAdornment>
                            ),
                            disableUnderline: true,
                        },
                        inputLabel: {
                            sx: {marginLeft: -1}
                        }
                    }
                    }
                    // color={'info'}
                    disabled={!editable}
                    fullWidth
                    size={size}
                    label={nombre}
                    required={requerido}
                    error={!!errors[dato]}
                    value={escogido}
                    onChange={e => setEscogido(e.target.value)}
                    helperText={errors[dato]?.message}
                    select>

                    {opciones.map((c, i) => (
                        <MenuItem key={`c-${i}`} value={c}>
                            {c}
                        </MenuItem>
                    ))}
                </TextField>
            </Grid>

            <Grid container size={4} sx={{justifyContent: 'flex-end'}}>
                <Button
                    disabled={!escogido}
                    onClick={() => agregar()}
                >Agregar</Button>
            </Grid>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={1}
                sx={{mt: 2}}
            >

                {selecciones.map((c, i) => (
                    <Chip color={'primary'} label={c} onDelete={() => borrar(i)}/>
                ))}

            </Grid>

        </Grid>


    )

}
export default IngresoSelectTextoArray

const opciones = ['Si', 'No']
